import { getFullName } from "@clockwise/web-commons/src/util/profile.util";
import { uniq } from "lodash";
import { TradeoffBlock } from "../../../../utils/types";

export const getNamesAndCountOfAffectedAttendeesFormatted = (
  tradeoffThreadItems: {
    aggregateAttendees: {
      isYou: boolean;
      profile: {
        familyName: string | null;
        givenName: string | null;
        externalImageUrl: string | null;
      } | null;
    }[];
  }[],
) => {
  const tradeoffThreadItemAttendees = uniq(
    tradeoffThreadItems.map((tradeoffBlock) => tradeoffBlock.aggregateAttendees).flat(),
  );

  const tradeoffEventsAttendeeNames = tradeoffThreadItemAttendees.map((attendee) => {
    if (attendee?.isYou) return "You";
    return getFullName(attendee?.profile);
  });

  const formatter = new Intl.ListFormat("en", { style: "long", type: "conjunction" });
  return {
    names: formatter.format(tradeoffEventsAttendeeNames),
    count: tradeoffEventsAttendeeNames.length,
  };
};

export const removeTradeoffsEventsAlsoInConsequences = ({
  tradeoffThreadItemsAll,
  yourCalDiffs,
  otherCalDiffs,
}: {
  tradeoffThreadItemsAll: TradeoffBlock[];
  yourCalDiffs: {
    eventId: string;
  }[];
  otherCalDiffs: {
    eventId: string;
  }[];
}) => {
  const consequenceIds = [
    ...yourCalDiffs.map((diff) => diff.eventId),
    ...otherCalDiffs.map((diff) => diff.eventId),
  ];
  const newTradeoffBlocks: TradeoffBlock[] = [];
  for (const block of tradeoffThreadItemsAll) {
    const blockWithoutConsequenceItems = block.schedulingTradeoffs.filter(
      (tradeoff) => !consequenceIds.includes(tradeoff?.externalEventId || ""),
    );
    if (blockWithoutConsequenceItems.length) {
      newTradeoffBlocks.push({
        ...block,
        schedulingTradeoffs: blockWithoutConsequenceItems,
      });
    }
  }

  return newTradeoffBlocks;
};
